import React from 'react'
import styled from 'styled-components'
import {SnackbarAction as RmwcSnackbarAction} from '@rmwc/snackbar'
import '@rmwc/snackbar/styles'

const StyledRmwcSnackbarAction = styled(RmwcSnackbarAction)``

const SnackbarAction = (props) => <StyledRmwcSnackbarAction {...props} />

export {SnackbarAction}
